import axiosInstance from './AxiosWrapper'
import { ENDPOINT_ROOMS } from './Endpoints'

export const getAllRooms = async () => {
  return await axiosInstance.get(ENDPOINT_ROOMS)
}
